import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { EntitlementsResponse } from '@adsk/alloy-provider';

/**
 * Creates a function for generating the URL for fetching project entitlements.
 *
 * @param fields The fields to include in the response.
 * @param classification The project classification to include in the response.
 * @param limit The number of entitlements to return.
 * @returns A function for generating the URL for fetching project entitlements.
 * This function returns a list of entitlements for a given user.
 * @param pageIndex The page of entitlements to return.
 * @param previousPageData The data from the previous page.
 * @param search A string to search for in the entitlements.
 * @returns The entitlements for the user.
 */
export function factoryProjectEntitlementsKey({
  path,
  fields,
  classification,
  limit,
  filterByProjectNumber,
}: {
  path: string;
  fields: string;
  classification: string;
  limit: number;
  filterByProjectNumber?: boolean;
}) {
  return (
    pageIndex: number,
    previousPageData: EntitlementsResponse,
    search?: string,
  ) => {
    if (previousPageData && !previousPageData.results) {
      return null; // reached the end
    }

    if (pageIndex === 0) {
      return (
        `${getAdminApiUrl()}${path}?` +
        new URLSearchParams({
          fields,
          'filter[classification]': classification,
          ...(search && { 'filter[name]': search }),
          ...(filterByProjectNumber &&
            search && { 'filter[jobNumber]': search }),
          ...(filterByProjectNumber &&
            search && { orFilters: ['name', 'jobNumber'].toString() }),
          limit: limit.toString(),
        }).toString()
      );
    }
    return previousPageData?.pagination?.nextUrl;
  };
}
